import * as actionTypes from "./actionTypes";

export const setSubscription = (subscription) => ({
    type: actionTypes.SET_SUBSCRIPTION,
    subscription,
});
